export const getQueryStringFromObject = (option: any) => {
  return Object.keys(option)
    .filter((key) => ![undefined, null, ""].includes(option[key]))
    .map((key) => `${key}=${option[key]}`)
    .join("&");
};

export const generateTeamAlias = (teamName) => {
  if (!teamName || teamName.trim() === "") {
    return "";
  }

  const words = teamName.split(" ").filter((word) => word.trim() !== "");
  let alias = "";
  if (words.length === 1) {
    alias = words[0].slice(0, 2).toUpperCase();
    if (alias.length === 1) {
      const randomLetter = String.fromCharCode(
        65 + Math.floor(Math.random() * 26)
      ); // A-Z
      alias += randomLetter; // Append a random letter
    }
  } else if (words.length === 2) {
    alias =
      words[0].slice(0, 1).toUpperCase() + words[1].slice(0, 1).toUpperCase();
  } else if (words.length === 3) {
    alias =
      words[0].slice(0, 1).toUpperCase() +
      words[1].slice(0, 1).toUpperCase() +
      words[2].slice(0, 1).toUpperCase();
  } else if (words.length >= 4) {
    alias =
      words[0].slice(0, 1).toUpperCase() +
      words[1].slice(0, 1).toUpperCase() +
      words[2].slice(0, 1).toUpperCase() +
      words[3].slice(0, 1).toUpperCase();
  }

  return alias;
};
